import { useState, useEffect } from 'react'
import { Breakpoint, breakpoints } from '../configs/breakpoints'

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null)
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const calculateBreakpoint = (providedWidth: number) => {
      if (providedWidth >= breakpoints['2xl']) return '2xl'
      if (providedWidth >= breakpoints.xl) return 'xl'
      if (providedWidth >= breakpoints.lg) return 'lg'
      if (providedWidth >= breakpoints.md) return 'md'
      if (providedWidth >= breakpoints.sm) return 'sm'
      return null
    }

    const handleResize = () => {
      setWidth(window.innerWidth)
      setBreakpoint(calculateBreakpoint(window.innerWidth))
    }

    // Initial calculation
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    breakpoint,
    width,
    isSm: width >= breakpoints.sm,
    isMd: width >= breakpoints.md,
    isLg: width >= breakpoints.lg,
    isXl: width >= breakpoints.xl,
    is2Xl: width >= breakpoints['2xl'],
    // Shorthand for common use cases
    isMobile: width < breakpoints.md,
    isTablet: width >= breakpoints.md && width < breakpoints.lg,
    isDesktop: width >= breakpoints.lg,
  }
}
